const Widget = (props) => {
  return <div {...props} className="typing-input-box"></div>;
};

export default Widget;
